import React from 'react'
import {Spin, DatePicker, Timeline, Form, Button,Input, InputNumber,message, Empty,Space,Row, Col} from 'antd';
import EssaModal from '@components/EssaModal/EssaModal';
import PropTypes from 'prop-types';
import Lang from "@components/Lang/Lang";
import {isEmpty,trim} from '@utils/utils';
import {postDeliveryList, postDeliveryListInfo, postBatchDelivery,downloadDeliverOrder} from '@/api/warehouseManagement/outWarehouse';
import {postWaitIntoWarehouseList, postInserIntoWarehouse} from '@/api/warehouseManagement/registration'
import { toFixedWithCommas} from "@utils/number-util";
import ShipperManagementAction from "../../../ShipperManagement.action";
import dayjs from 'dayjs';
import "./index.less"
/**
 * 物流跟进
 *
 * @author FJJ
 * @version 1.0
 *
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class LogisticsFollowUp extends React.Component {
    static defaultProps = {
        containerId:"", //数据源
    }
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            loading:false,
            // 值
            initialValues:{
                trackTime: dayjs(),
            },
            list:[]
        }
    }
    formRef = React.createRef();
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    // 赋值
    change(field,iType){
        let obj = this.state;
        // if(field=="kilometer"){
        //     // ^[1-9]d*$
        //     const patrn = /^[1-9]d*$/;
        //     if(!patrn.test(iType)){
        //         this.setState({
        //             objErr:{
        //                 field:
        //             }
        //         })
        //         return false
        //     }
        // }
        obj[field] = iType;
        this.setState(obj);
    }
    /*
    * 打开 并查询详情
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=239#7876
    * */
    open(flag=false){
        if(flag){
           this.getList()
        }
        this.setState({
            isModalVisible: flag
        })
    }
    getList(){
        const { containerId} = this.props;
        const data = {
            containerId:containerId
        }
        this.loading(true);
        ShipperManagementAction.autoFetchAction(data,"/service/mg/container/queryTrack").then(res=>{
            this.loading(false);
            const resData = res.data;
            const { success, valid,models} = resData;
            if (success &&valid) {
                // 成功
                this.setState({
                    list: models
                })
            }else if(resData.message){
                message.warning(resData.message)
            }else {
                message.warning(Lang({id:"BaoCunShiBai"}))
            }
        }).catch(err=>{
            this.loading(false);
            console.log('出错了',err)
        })
    }
    /*
    * 新增物流跟进
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=239#7875
    * */
    save(data={}){
        this.loading(true);
        ShipperManagementAction.autoFetchAction(data,"/service/mg/container/addTrack").then(res=>{
            this.loading(false);
            const resData = res.data;
            const { success, valid,} = resData;
            if (success &&valid) {
                // 成功
                message.success(Lang({id:"XinZengJiLuChengGong",default:"新增记录成功"}));
                // 新增后清空公里数
                this.formRef.current.setFieldsValue({
                    kilometer:null
                });
                // const {initialValues} = this.state;
                // let clearData = {...initialValues};
                // clearData["kilometer"] = null;
                // console.log("clearData",clearData)
                // this.setState({
                //     initialValues:clearData
                // })
                this.getList()
            }else if(resData.message){
                message.warning(resData.message)
            }else {
                message.warning(Lang({id:"BaoCunShiBai"}))
            }
        }).catch(err=>{
            this.loading(false);
            console.log('出错了',err)
        })
    }
    /**
     * 提交接口
     *  调用获取所有数据
     * */
    submit= async() => {
            try {
                const values = await this.formRef.current.validateFields();
                const { trackTime,kilometer } = values;
                if(!isEmpty(kilometer)&&!isEmpty(trackTime)){
                    const { containerId} = this.props;
                    const data = {
                        kilometer:kilometer,
                        trackTime: dayjs(trackTime).valueOf(),
                        containerId:containerId
                    }
                    this.save(data);
                }
            } catch (errorInfo) {
            }
    }
    renderChild(list=[]){
        let childList = []
        list.forEach((item,inx)=>{
            childList.push({
                children: this.stepItem(item),
                color: inx==0?'red':'gray',
            })
        })
        return childList
    }
    stepItem(item={},index) {
        return (
            <div className="fw_400 font_14 black45" key={"item_key_"+index}>
                <div className={"black66 mb_4 font_12"}>
                    {item.trackTime&&dayjs(item.trackTime).format('YYYY-MM-DD HH:mm:ss')}
                </div>
                <div className={"black89 mb_4"}>
                    {/*{Lang({id:"JiGuiJuLiCangKu",default:"集柜距离仓库"})}<span className={"ml_4"}>{item.num}</span>km*/}
                    {item.trackDesc}
                </div>

            </div>
        )
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
        if(this.showTimer)clearTimeout(this.showTimer)
    };
    render() {
        const {loading, isModalVisible,initialValues, list} = this.state;
        return (<>
                <Button className={"ant-btn-primary-blue"} onClick={()=>this.open(true)}>{Lang({id: "WuLiuGenJin",default: "物流跟进"})}</Button>
                {isModalVisible&&<EssaModal title={Lang({id:"WuLiuGenJin",default:"物流跟进"})}
                                            open={isModalVisible}
                                            footer={null}
                                            width={550}
                                            onCancel={()=>this.open(false)}
                                            onOk={()=>this.open()}>
                    <Spin spinning={loading}>
                        <div className={"customsClearanceWrap black89"}>
                            <p className={"mb_8"}>{Lang({id:"GengXinWuLiuXinXi",default:"更新物流信息"})}</p>
                            <div className={"flex-item"}>
                                <Form ref={this.formRef} onFinish={this.submit} colon={false} initialValues={initialValues}>
                                    <Space.Compact style={{ flex: '1' }}>
                                        <Form.Item name="trackTime">
                                            <DatePicker style={{width: "150px"}} onChange={(date)=>this.change('trackTime',date)} />
                                        </Form.Item>
                                            <Form.Item
                                                name="kilometer"
                                                onChange={this.updateTotal}
                                                rules={[
                                                    {pattern: /^\+?[1-9][0-9]*$/, message: __getServerLanguage('QingShuRuZhengZhengShu')}
                                                ]}
                                            >
                                                <Input style={{ width: '100%' }} addonAfter="km" placeholder={Lang({id:"QingShuRuJuLiCangKuGongLiShu",default:"请输入距离仓库公里数"})}></Input>
                                            </Form.Item>

                                        {/*<InputNumber addonAfter="km" style={{ width: '100%' }}*/}
                                                     {/*onChange={(value)=>this.change('kilometer',value)}*/}
                                                     {/*placeholder={Lang({id:"QingShuRuJuLiCangKuGongLiShu",default:"请输入距离仓库公里数"})} />*/}
                                        <Button className={"ml_8"} type="primary" onClick={()=>this.submit()}>{Lang({id:"XinZeng",default:"新增"})}</Button>
                                    </Space.Compact>
                                </Form>
                            </div>
                        </div>
                        {list.length>0?<div className={'modalLogisticsWrap'}>
                            <Timeline items={this.renderChild(list)} />
                        </div>:<div className={"mt_16"}>
                            <Empty mage={Empty.PRESENTED_IMAGE_SIMPLE} description={Lang({id: 'ZanWuShuJu',default:'暂无数据'})} />
                        </div>}
                    </Spin>
                </EssaModal>}
            </>
        )
    }
}